import axios from "axios";
import baseURL from "../configs/api";

export const post_ForgotPassword = (emailAddress: string, tenantId: string) => {
    console.log(tenantId)
    return axios({
        url: `${baseURL}Auth/ForgotPassword?userEmail=${encodeURIComponent(emailAddress)}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: {}
    }).then(response => response.data);
}
